import React, {Component} from 'react';
import {
    AJAX,
    showPreloader,
    show_success_popup,
    hidePreloader,
    gTagClickEvent,
    addStepLog,
    setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {withRouter} from "react-router";
import {gTagClickEventValue} from "../booking/frontend_script";

class VehicleStatePage extends Component {
    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.unlockVehicleAjax = this.unlockVehicleAjax.bind(this);
        this.lockVehicleAjax = this.lockVehicleAjax.bind(this);
        this.setDisallowGoBack = this.setDisallowGoBack.bind(this);
        this.handleSetPage({name: 'vehicle_state', params: false});
        this.state = {redirect: false};

        if (this.props.disallowGoBack) {
            this.state.redirect = '';
        }
        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    handleSetPage(options) {
        if (options.name == 'vehicle_state')
            addStepLog('Vehicle State page');
        this.props.handleSetPage(options);
    }

    setDisallowGoBack() {
        this.props.setDisallowGoBack(true);
    }

    unlockVehicleAjax(event, retryCount = 0) {
        if (event) event.preventDefault();
        addStepLog('Press Button Unlock on Vehicle State page');
        let params = {
            action: 'api/booking/unlock_vehicle',
            session_key: this.props.session_key,
            global_operation: this.props.global_operation
        };
        try {
            gTagClickEventValue('click_to_unlock', {'event_category': 'vehicle_unlocking', 'event_label': ''});
        }
        catch (e) {
            navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent(e.message)+'&origin=app');
        }
        gTagClickEvent('vehicle_unlocking','');

        let t = this;

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                const retryMessage = retryCount > 0 ? `Connection Error. Retrying to connect to vehicle. Attempt ${retryCount + 1}` : '';
                showPreloader(retryMessage);
            },
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1) {
                    addStepLog('Unlock successful on Vehicle State page');
                    let redirectTo = 'where_keys';
                    if (resp.data.hasOwnProperty('unlock_note')) {
                        let note = resp.data.unlock_note;
                        t.props.handleSetUnlockNote(note);
                        if (typeof note === 'string' && note.length > 0) {
                            redirectTo = 'check_fuel';
                        }
                    }
                    t.props.handleSetBookingState(resp.data);
                    // t.props.handleUpdateVehicleState('unlocked');
                    t.props.handleSetVehicleIsLock(false);
                    show_success_popup('Vehicle has been unlocked');
                    window.localStorage.setItem('end_hire', t.props.vehicle_data.DropOffDate);
                    window.localStorage.setItem('start_timer', '1');
                    window.localStorage.setItem('active_session_key', params.session_key);
                    if (typeof window.startTimer === 'function')
                        window.startTimer();
                    setTimeout(() => {t.setDisallowGoBack(); t.setState({redirect: redirectTo});}, 2000);
                }
                else {
                    if (retryCount < 2) {
                        showPreloader('Connection Error. Retrying to connect to vehicle. Attempt ' + (retryCount + 1));
                        setTimeout(() => {
                            t.unlockVehicleAjax(null, retryCount + 1);
                        }, 2000);
                    }
                    else {
                        if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                            showPopupWithGoBack(t.error_msg(resp.errors.main));
                        }
                        else {
                            showPopupWithGoBack( t.error_msg('All retry attempts have failed.'));
                        }
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Exception occurred on ' + t.props.global_operation + ' ' + t.props.client_data.resno + ': ' + resp.message )+'&origin=app');

                // Check if client type requires retry logic
                if (retryCount < 2) {
                    showPreloader('Connection Error. Retrying to connect to vehicle. Attempt ' + (retryCount + 1));
                    setTimeout(() => {
                        t.unlockVehicleAjax(null, retryCount + 1);
                    }, 2000);
                }
                else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(t.error_msg(resp.errors.main));
                    }
                    else {
                        showPopupWithGoBack( t.error_msg('All retry attempts have failed.'));
                    }
                }
            }
        });
    }

    error_msg(msg) {
        return '<div>' + msg + '<br/>Please wait 2 minutes and then try again. <br/>If it still fails, please call Go With The Gecko support on <a href="tel:1300826883">1300 826 883</a>.</div>';
    }

    lockVehicleAjax(event, retryCount = 0) {
        if (event) event.preventDefault();
        addStepLog('Press Button Lock on Vehicle State page');
        let params = {
            action: 'api/booking/lock_vehicle',
            session_key: this.props.session_key,
            global_operation: this.props.global_operation
        };

        try {
            gTagClickEventValue('click_to_lock', {'event_category': 'vehicle_locking', 'event_label': ''});
        }
        catch (e) {
            navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent(e.message)+'&origin=app');
        }
        gTagClickEvent('vehicle_locking','');

        let t = this;

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                const retryMessage = retryCount > 0 ? `Connection Error. Retrying to connect to vehicle. Attempt ${retryCount + 1}` : '';
                showPreloader(retryMessage);
            },
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    addStepLog('Lock successful on Vehicle State page');
                    t.props.handleSetBookingState(resp.data);
                    t.props.handleSetVehicleIsLock(true);
                    show_success_popup('Vehicle has been locked & the engine has been immobilised');
                    window.localStorage.removeItem('end_hire');
                    window.localStorage.removeItem('start_timer');
                    window.localStorage.removeItem('active_session_key');
                    if (typeof window.stopTimer === 'function') {
                        window.stopTimer();
                    }
                    setTimeout(() => {
                        t.setDisallowGoBack();
                        addStepLog('Thank you page');
                        t.setState({redirect: 'thank_you'});
                    }, 2000);
                }
                else {
                    if (retryCount < 2) {
                        showPreloader('Connection Error. Retrying to connect to vehicle. Attempt ' + (retryCount + 1));
                        setTimeout(() => {
                            t.lockVehicleAjax(null, retryCount + 1);
                        }, 2000);
                    } else {
                        if ( resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                            showPopupWithGoBack( t.error_msg(resp.errors.main));
                        }
                        else {
                            showPopupWithGoBack( t.error_msg('All retry attempts have failed.'));
                        }
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Exception occurred on ' + t.props.global_operation + ' ' + t.props.client_data.resno + ': ' + resp.message )+'&origin=app');
                // Check if client type requires retry logic
                if (retryCount < 2) {
                    showPreloader('Connection Error. Retrying to connect to vehicle. Attempt ' + (retryCount + 1));
                    setTimeout(() => {
                        t.lockVehicleAjax(null, retryCount + 1);
                    }, 2000);
                }
                else {
                    if ( resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(t.error_msg(resp.errors.main));
                    }
                    else {
                        showPopupWithGoBack( t.error_msg('All retry attempts have failed.'));
                    }
                }
            }
        });
    }

    render() {
        let text;
        let vehicleIsLock = this.props.vehicleIsLock;
        let global_operation = this.props.global_operation;

        if (this.state.redirect !== false)
            return <Redirect push to={'/'+this.state.redirect} />;

        switch (global_operation) {
            case 'unlock':
                text = 'Please stand by the vehicle and press unlock';
                break;
            case 'lock':
                text = 'Please stand by the vehicle and press lock';
                break;
        }

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="my-4">{text}</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center">
                        <img className={"client_vehicle" + (!vehicleIsLock ? ' unlocked' : '')} src={this.props.car_image} alt=""/>
                        <div className="mb-4">
                            <span><b>{this.props.vehicle_data.RegistrationNo}</b></span>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center">
                        { global_operation === 'unlock' ? (
                            <button type="button" className="base-input green mb-4"
                                    onClick={this.unlockVehicleAjax.bind(this)}>
                                UNLOCK
                            </button>
                        ) : (
                            <button type="button" className="base-input red mb-4"
                                    onClick={this.lockVehicleAjax.bind(this)}>
                                LOCK
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>);
    }
}

const VehicleStatePageR = withRouter(VehicleStatePage);
export default VehicleStatePageR;